import type { Event } from '@patsnap/tahiti-core/common/event';
import type { SpecificationContent, SpecificationGenContentState, SpecificationParagraph } from '../types/specification-gen-content';
import type { SpecificationStreamContent } from '../types/specification';

export const SpecificationGenContentService = Symbol.for('SpecificationGenContentService');

export interface SpecificationGenContentService {
    readonly onStateChange: Event<SpecificationGenContentState>;

    /** 监听内容生成中 */
    readonly onContentGenerating: Event<SpecificationStreamContent<SpecificationContent>>;

    /** 获取状态 */
    getState(): SpecificationGenContentState;

    updateState(state: SpecificationGenContentState): void;

    /**
     * 初始化
     * @param taskId 任务ID
     */
    init(taskId: string): Promise<void>;

    regenerate(): Promise<void>;

    stop(): void;

    /**
     * 更新段落内容
     * @param paragraph 段落
     */
    updateParagraphContent(paragraph: SpecificationParagraph): Promise<void>;
    /**
     * 删除段落内容
     * @param paragraph 段落
     */
    deleteParagraphContent(paragraph: SpecificationParagraph): Promise<void>;
}
